import { i18n } from '@vendor/libs/lang/lang';
import { bootstrap } from '@vendor/js/theme/bootstrap';
import Common from '@vendor/js/common';
const _BillingCycleEntityPaymentsBulkEditHandler = (function () {
    const table = $('[data-app-entity_payments="table"]');
    const markRowAsEdited = (row) => {
        row.find('td:last').html(`
      <span class="text-info" data-bs-toggle="tooltip" title="${i18n.trans('models/billing_cycle_entity_payments.pages.bulk_edit.row_edited')}">
        <i class="bx bx-info-circle"></i>
      </span>
    `);
        row.addClass('bg-info-light');
        table.DataTable().row(row).invalidate();
        table.DataTable().draw();
        $('[data-bs-toggle="tooltip"]').each(function () {
            new bootstrap.Tooltip(this);
        });
    };
    return {
        // Public functions
        init: function () {
            const inputs = $('input[name*="paid_amount"]');
            const checkboxes = $('input[name*="is_paid"]');
            const form = $('#bulk_edit_entity_payments_form');
            checkboxes.on('change', function () {
                const id = $(this).attr('name')?.split('[')[1].split(']')[0];
                const input = $(`input[name="paid_amount[${id}]"]`);
                markRowAsEdited($(this).closest('tr'));
                input.attr('disabled', $(this).is(':checked'));
            });
            form.on('submit', function (e) {
                e.preventDefault();
            });
            inputs.on('change', function () {
                markRowAsEdited($(this).closest('tr'));
            });
            form.on('submit', function (e) {
                e.preventDefault();
                table.DataTable().search('').draw();
                Common.submitAsynchronously(this, {
                    fillInputErrors: true,
                });
            });
        },
    };
})();
window.BillingCycleEntityPaymentsBulkEditHandler =
    _BillingCycleEntityPaymentsBulkEditHandler;
